// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product {
  background-color: #fff;
  border-radius: 5px;
  min-height: 490px;
  padding: 20px 10px;
  position: relative;
}
.add-product .group {
  margin-top: 30px;
  padding: 10px 20px;
}
.add-product .group .mb-2 {
  display: flex;
  gap: 10px;
}
.add-product .group .mb-2 .mb-3 {
  width: 50%;
}
.add-product .loading-spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 55;
  background-color: rgba(255, 255, 255, 0.466);
}
.add-product button:disabled {
  opacity: 0.7;
  cursor: no-drop;
}
.dark .add-product {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
}`, "",{"version":3,"sources":["webpack://./src/components/Products/AddProduct/addProduct.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAAE;EACE,gBAAA;EACA,kBAAA;AAEJ;AADI;EACE,aAAA;EACA,SAAA;AAGN;AAFM;EACE,UAAA;AAIR;AAAE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,4CAAA;AAEJ;AAAE;EACE,YAAA;EACA,eAAA;AAEJ;AAIE;EACE,wCAAA;EACA,sBAAA;AAFJ","sourcesContent":[".add-product {\n  background-color: #fff;\n  border-radius: 5px;\n  min-height: 490px;\n  padding: 20px 10px;\n  position: relative;\n  .group {\n    margin-top: 30px;\n    padding: 10px 20px;\n    .mb-2 {\n      display: flex;\n      gap: 10px;\n      .mb-3 {\n        width: 50%;\n      }\n    }\n  }\n  .loading-spinner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 55;\n    background-color: rgba(255, 255, 255, 0.466);\n  }\n  button:disabled {\n    opacity: 0.7;\n    cursor: no-drop;\n  }\n  label {\n  }\n}\n.dark {\n  .add-product {\n    background-color: var(--darkSecondColor);\n    color: var(--darkFont);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
